import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { LoginPage } from "@/pages/LoginPage";
import { SuperuserDashboardPage } from "@/pages/superuser/DashboardPage";
import { AdminDashboardPage } from "@/pages/admin/DashboardPage";
import { MyCompanyPage } from "@/pages/admin/MyCompanyPage";
import { PlanningPage } from "@/pages/admin/PlanningPage";
import { ReportsPage } from "@/pages/admin/ReportsPage";
import { Layout } from "@/components/layout/Layout";
import { ProtectedRoute } from "./ProtectedRoutes";
import { DefaultRedirect } from "./DefaultRedirect";
import { CompaniesPage } from "@/pages/superuser/CompaniesPage";
import { CompanyDetailsPage } from "@/pages/superuser/CompanyDetailsPage";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import { Toaster } from "sonner";
import { EmployeesList } from "@/pages/EmployeesList";
import { EmployeeDetails } from "@/pages/EmployeeDetails";
import SessionsPage from "@/pages/SessionsPage";
import { SessionAlertsPage } from "@/pages/admin/SessionAlertsPage";
const Index = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route // Route pour afficher le dashboard SUPERUSER
              path="/superuser/dashboard"
              element={
                <ProtectedRoute roles={["SUPERUSER"]}>
                  <Layout>
                    <SuperuserDashboardPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route // Route pour afficher les entreprises
              path="/superuser/companies"
              element={
                <ProtectedRoute roles={["SUPERUSER"]}>
                  <Layout>
                    <CompaniesPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route // Route pour afficher les détails d'une entreprise
              path="/superuser/companies/:id"
              element={
                <ProtectedRoute roles={["SUPERUSER"]}>
                  <Layout>
                    <CompanyDetailsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route // Route pour afficher les comptes administrateurs
              path="/superuser/users/admins"
              element={
                <ProtectedRoute roles={["SUPERUSER"]}>
                  <Layout>
                    <EmployeesList
                      defaultRole="ADMIN" // Par défaut, on affiche les comptes administrateurs
                    />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route // Route pour afficher les employés
              path="/superuser/users/employees"
              element={
                <ProtectedRoute roles={["SUPERUSER"]}>
                  <Layout>
                    <EmployeesList
                      defaultRole="EMPLOYEE" // Par défaut, on affiche les employés
                    />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route // Route pour afficher les détails d'un utilisateur
              path="/users/:id"
              element={
                <ProtectedRoute roles={["SUPERUSER", "ADMIN"]}>
                  <Layout>
                    <EmployeeDetails />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route // Route pour afficher le dashboard ADMIN
              path="/admin/dashboard"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <Layout>
                    <AdminDashboardPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route // Route pour afficher les employés
              path="/admin/employees"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <Layout>
                    <EmployeesList defaultRole="EMPLOYEE" />
                  </Layout>
                </ProtectedRoute>
              }
            />
            
            <Route // Route pour afficher le planning
              path="/admin/planning"
              element={
                <ProtectedRoute roles={["ADMIN", "SUPERUSER"]}>
                  <Layout>
                    <PlanningPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route // Route pour afficher "Mon Entreprise"
              path="/admin/my-company"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <Layout>
                    <MyCompanyPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route // Route pour les rapports horaires
              path="/admin/reports"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <Layout>
                    <ReportsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/sessions"
              element={
                <ProtectedRoute roles={["SUPERUSER", "ADMIN"]}>
                  <Layout>
                    <SessionsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route // Route pour afficher les sessions à vérifier
              path="/admin/alerts"
              element={
                <ProtectedRoute roles={["ADMIN"]}>
                  <Layout>
                    <SessionAlertsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<DefaultRedirect />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
};

export default Index;
